export default __webpack_public_path__ + "static/media/animated_sound.1588df94.gif";